import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button, TextField } from '@shopify/polaris'

import Text from 'components/common/Text'
import { SHOPIFY_TEXT, SHOPIFY_TEXT_HEADER } from 'components/styles'
import { sendPreviewSms } from 'controllers/shopifyApp'

const Wrapper = styled.div`
  height: 40em;
  display: flex;
  align-items: center;
`
const Container = styled.div`
  width: 40em;
  display: flex;
  flex-direction: column;
`
const ButtonsContainer = styled.div`
  margin-top: 3em;
  width: 36em;
  display: flex;
  justify-content: flex-start;
  font-size: 0.8em;
`
const InputContainer = styled.div`
  display:flex;
  flex-direction: row;
  margin-left: 2em;

  .Polaris-TextField {
    width: 15em;
    height: 3em;
  }
`
const MiddleContainer = styled.div`
  display: flex;
  margin-top: 2em;
  width: 28em;
`

class FinalSceneDesc extends Component {

  constructor (props) {
    super(props)
    this.state = {
      inputVisible: false,
      phone: ''
    }
  }

  onSendToDeviceClick = () => this.setState({inputVisible: true})
  onPhoneEnter = (v) => this.setState({phone: v})

  send = () => {
    const { dispatch } = this.props
    const { phone } = this.state
    dispatch(sendPreviewSms(phone))
    this.setState({inputVisible: false})
  }


  renderSendToDevice = () => {
    const { inputVisible, phone } = this.state
    if (inputVisible) {
      return (
        <InputContainer>
          <TextField
            placeholder='Enter your mobile number'
            value={phone}
            onChange={this.onPhoneEnter}
            type='tel'
            autoComplete
          />
          <Button size='slim' onClick={this.send}>Send</Button>
        </InputContainer>
      )
    } else {
      return (
        <InputContainer>
          <Button plain onClick={this.onSendToDeviceClick} size='slim'>Send to phone to preview</Button>
        </InputContainer>
      )
    }

  }

  render () {
    const { goLive, onBack } = this.props
    return (
      <Wrapper>
        <Container>
          <Button plain onClick={onBack}>{'< Return to editor'}</Button>
          <Text size='large' color={SHOPIFY_TEXT_HEADER}>You did it!  Take a look at your mobile Whimm</Text>
          <MiddleContainer>
            <Text containerStyle={`line-height: 1.4em;`} color={SHOPIFY_TEXT}>
              Review the final version of your enhanced call to action in the phone simulator on the left. If you are happy with what you see, click "Go Live" below to publish the Whimm to your Shopify website. You can view the specific sections of your CTA below.
            </Text>
          </MiddleContainer>
          <ButtonsContainer>
            <Button primary onClick={goLive} size='slim'>Publish live</Button>
            {this.renderSendToDevice()}
          </ButtonsContainer>
        </Container>
      </Wrapper>
    )
  }
}


FinalSceneDesc.propTypes = {
  onBack: PropTypes.func,
  goLive: PropTypes.func
}

export default connect()(FinalSceneDesc)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/FinalSceneDesc.js